<template>
  <div id="help">
    <feedback v-if="feedbackShow"
              @onOff="typeShow"
              @updateQuestionId="updateQuestionId"
              @changeFeedbackShow="changeFeedbackShow"
              :label="label"
              :questionId="questionId"
              :editQuiz="editQuiz"
              :props_questionTitle="searchQuiz"
              @selectQuestion="selectQuestion"></feedback>
    <evaluation v-if="evaluationShow" @onOff="typeShow" @confirm="confirm"></evaluation>
    <unanswered v-if="unansweredShow" @onOff="typeShow" @confirm="confirm"></unanswered>
    <!-- 搜索 -->
    <div class="search-wrap">
      <div class="search">
        <div class="search-title">帮助与反馈</div>
        <div class="search-input">
          <div class="add" @click="addQuestion"></div>
          <div class="input-wrap">
            <label>
              <input
                ref="searchInput"
                v-click-outside="closeSearchList"
                :class="{'hide-icon': isHideIcon}"
                type="text"
                placeholder="搜索"
                v-model.trim="searchQuiz"
                @focus="openSearchList"
                @compositionend="inputEnd"
                @compositionstart="inputStart"
                @keydown.up.prevent="handle_selecteQuestion(-1)"
                @keydown.down.prevent="handle_selecteQuestion(1)"
                @keydown.enter.prevent="handle_updateQuestionDetail_page">
            </label>
            <div class="search-list" v-if="isSearchList">
              <div class="search-item-wrap" v-show="!isNotFoundList">
                <div class="search-item"
                     v-for="(item, index) in searchResultList"
                     :key="item.id"
                     :class="{'selected-item': selectSearchListIndex === index}"
                     @click="handler_getQuizDetail(item.id)"
                     @mouseover.prevent="handler_selectQuiz(index)">{{ item.topic }}</div>
              </div>
              <div v-show="isNotFoundList" class="not-found-list">
                <div class="title">没有想要的内容？快去提问吧！</div>
                <div class="quiz" @click="addQuestion">去提问</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 主体内容 -->
    <div class="content" :class="[isQuestionDetail ? '' : 'only-one']">
      <!-- 问题列表 -->
      <question-list
        :label="label"
        :isSelectType="isSelectType"
        :isSelectQuizId="selectedQuestionId"
        @showQuestionType="showQuestionType"
        @feedback="feedback"
        @changeQuestionType="changeQuestionType"
        @getQuestionDetail="getQuestionDetail"
        @closeQuestionType="closeQuestionType"></question-list>

      <!-- 问题详情 -->
      <question-detail
        @getQuestionDetail="getQuestionDetail"
        v-if="isQuestionDetail"
        :label="label"></question-detail>

      <!-- 相关问题 -->
      <question-related
        v-if="isQuestionDetail"
        :label="label"
        @handler_getQuestionDetail="getQuestionDetail"
        @unanswered="unanswered"
        @answered="answered"
        @editQuestion="editQuestion"
        @cancelQuestion="cancelQuestion"></question-related>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import questionType from '../questionType/question-type'
import feedback from '../feedback/feedback'
import evaluation from '../evaluation/evaluation'
import unanswered from '../unanswered/unanswered'
import questionList from '../question-list/question-list'
import questionDetail from '../question-detail/question-detail'
import questionRelated from '../question-related/question-related'
import clickOutside from '../../directives/click-outside/index'
import {getUrlParam} from '../../tools/getUrlParams/index'
import {MessageBox, Message} from 'element-ui'

export default {
  name: 'help',
  data () {
    return {
      questionTypeId: -1,
      selectSearchListIndex: 0,
      questionId: 0,
      questionPage: [],
      isSelectType: false,
      // 0: 热门问题，1: 我的反馈
      label: 0,
      messageContent: '',
      feedbackShow: false,
      evaluationShow: false,
      unansweredShow: false,
      editQuiz: false,
      pageCount: 1,
      searchQuiz: '',
      searchTime: null,
      searchResultList: [],
      isSearchList: false,
      isNotFoundList: false,
      isFocus: false,
      redPointTime: null,
      isHideIcon: false,
      selectedQuestionId: -1,  // 当前选中查看的问题
    }
  },
  components: {
    questionType,
    feedback,
    evaluation,
    unanswered,
    questionList,
    questionDetail,
    questionRelated
  },
  created () {
    // 未登录则不调接口
    if (this.getUserId === '' || this.getUserId === undefined) {
      return
    }
    let quizId = 0
    if (this.$route.query.questionId) {
      this.selectedQuestionId = quizId = Number.parseInt(this.$route.query.questionId)
    }
    this.init(quizId)
  },
  directives: {
    clickOutside
  },
  computed: {
    ...mapGetters({
      getQuestionPage: 'getQuestionPage',
      getQuizDetail: 'getQuestionDetail',
      getPageSize: 'getPageSize',
      getCommentPageSize: 'getCommentPageSize',
      getLoading: 'getLoading',
      getUserId: 'getUserId'
    }),
    isQuestionDetail () {
      return Boolean(this.getQuizDetail.id)
    },
    getRouterAddress () {
      if (this.$route.query) {
        let query = {
          questionId: this.$route.query.questionId,
          taskHash: this.$route.query.questionHash
        }
        return query
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions([
      'action_getHotQuestionPage',
      'action_getClassifyQuestionPage',
      'action_getUserQuestionPage',
      'action_getQuestionDetails',
      'action_getQuestionMessagePage',
      'action_addQuestionMessage',
      'action_evaluateQuizSolution',
      'action_userUpdateQuestion',
      'action_uerCancelsQuestion',
      'action_getRelatedQuizPage',
      'action_searchQuestionPage',
      'action_getQuizAllDetail',
      'action_queryQuizRedPoint',
      'setQuestionDetail',
      'setMessageDetail',
      'setRelatedQuizDetail',
      'setQuestionPage',
      'setPageCount',
      'setRedPoint',
      'setAllQuestionCount',
      'setLoading',
      'setDetailLoading',
      'setMessageLoading'
    ]),
    init (quizId) {
      this.setLoading(true)
      if (quizId) {  // 判断是否是从【帮助与反馈】页点击问题卡片跳转过来的
        if (this.$route.query.label) {
          this.label = Number.parseInt(this.$route.query.label)
        }
        this.initQuestionListData(quizId)
      } else {
        if (this.$route.params.label) {
          this.label = Number.parseInt(this.$route.params.label)
        }
        this.initQuestionListData(0, true)
      }
      clearTimeout(this.redPointTime)
      this.redPointTime = setTimeout(() => {
        this.action_queryQuizRedPoint().then(res => {
          if (res.erpCode === '000') {
            this.setRedPoint(res.erpData)
          } else {
            this.showMessage(res.erpMsg || '获取未读红点失败')
          }
        })
      }, 1000)
    },
    initQuestionListData(quizId = 0,pushHelp = false) {
      if (this.label === 0) { // 点击【帮助与反馈】页热门问题详情跳转过来的
        let params = {
          currentPage: 0,
          pageSize: this.getPageSize
        }
        this.action_getHotQuestionPage(params).then(res => {
          this.setLoading(false)
          if (res.erpCode === '000') {
            if (pushHelp) {
              this.$router.push({path: '/help'})
            }
            let count = res.erpData.totalCount ? Math.ceil(res.erpData.totalCount / params.pageSize) : 1
            this.setQuestionPage(res.erpData.pageItem)
            this.setAllQuestionCount(res.erpData.totalCount)
            this.setPageCount(count)
          } else {
            this.initErrorMessage(res, '获取问题列表失败')
          }
        })
        this.action_getQuizAllDetail(quizId).then(res => {
          this.questionId = Number.parseInt(quizId)
        })
      } else {  // 点击【帮助与反馈】页我的反馈问题详情跳转过来的
        let params = {
          currentPage: 0,
          pageSize: this.getPageSize
        }
        this.action_getUserQuestionPage(params).then(res => {
          this.setLoading(false)
          this.label = 1
          if (res.erpCode === '000') {
            if (pushHelp) {
              this.$router.push({path: '/help'})
            }
            let count = res.erpData.totalCount ? Math.ceil(res.erpData.totalCount / params.pageSize) : 1
            this.setQuestionPage(res.erpData.pageItem)
            this.setAllQuestionCount(res.erpData.totalCount)
            this.setPageCount(count)
          } else {
            this.initErrorMessage(res, '获取问题列表失败')
          }
        })

        if (quizId) {
          this.action_getQuizAllDetail(quizId).then(res => {
            this.questionId = Number.parseInt(quizId)
          })
        }
      }
    },
    initErrorMessage(res, text) {
      let msg = res.erpMsg || text
      this.$message({
        showClose: true,
        message: msg,
        type: 'warning'
      })
    },
    updateQuestionId (id) {
      this.questionId = id
    },
    handler_selectQuiz(index) {
      this.selectSearchListIndex = index
    },
    handle_selecteQuestion(n) {
      if (!this.searchResultList.length) {
        return false
      }
      let index = this.selectSearchListIndex + n
      // 键盘上下键都能实现循环选择
      if (index < 0) {
        index = this.searchResultList.length - 1
      } else if (index >= this.searchResultList.length) {
        index = 0
      }
      this.selectSearchListIndex = index
    },
    handle_updateQuestionDetail_page() {
      // 没有搜索结果则不更新详情
      if (!this.searchResultList.length) {
        return false
      }
      let id = this.searchResultList[this.selectSearchListIndex].id
      this.handler_getQuizDetail(id)
      this.isSearchList = false
      this.$refs.searchInput.blur()  // 手动让搜索输入框失去焦点
    },
    inputEnd () {
      if (this.searchQuiz === '') {
        this.isHideIcon = false
      }
    },
    inputStart () {
      this.isHideIcon = true
    },
    changeQuestionType (typeId) {
      let params
      this.setLoading(true)
      if (typeId === -1) {
        params = {
          currentPage: 0,
          pageSize: this.getPageSize
        }
        this.action_getHotQuestionPage(params).then(res => {
          this.setLoading(false)
          if (res.erpCode === '000') {
            this.questionTypeId = typeId
            let count = res.erpData.totalCount ? Math.ceil(res.erpData.totalCount / params.pageSize) : 1
            this.setQuestionPage(res.erpData.pageItem)
            this.setAllQuestionCount(res.erpData.totalCount)
            this.setPageCount(count)
            this.isSelectType = false
            this.label = 0
          } else {
            this.showMessage(res.erpMsg || '获取问题列表出错')
          }
        })
      } else {
        params = {
          type: typeId,
          currentPage: 0,
          pageSize: this.getPageSize
        }
        this.action_getClassifyQuestionPage(params).then(res => {
          this.setLoading(false)
          if (res.erpCode === '000') {
            this.questionTypeId = typeId
            let count = res.erpData.totalCount ? Math.ceil(res.erpData.totalCount / params.pageSize) : 1
            this.setQuestionPage(res.erpData.pageItem)
            this.setAllQuestionCount(res.erpData.totalCount)
            this.setPageCount(count)
            this.isSelectType = false
            this.label = 0
          } else {
            this.showMessage(res.erpMsg || '获取问题列表出错')
          }
        })
      }
    },
    showQuestionType () {
      if (this.label !== 0) {
        this.changeQuestionType(this.questionTypeId)
      } else {
        this.isSelectType = !this.isSelectType
      }
      clearTimeout(this.redPointTime)
      this.redPointTime = setTimeout(() => {
        this.action_queryQuizRedPoint().then(res => {
          if (res.erpCode === '000') {
            this.setRedPoint(res.erpData)
          }
        })
      }, 1000)
    },
    feedback () {
      this.label = 1
      this.isSelectType = false
      let params = {
        currentPage: 0,
        pageSize: this.getPageSize
      }
      this.setLoading(true)
      this.action_getUserQuestionPage(params).then(res => {
        this.setLoading(false)
        if (res.erpCode === '000') {
          let count = res.erpData.totalCount ? Math.ceil(res.erpData.totalCount / params.pageSize) : 1
          this.setQuestionPage(res.erpData.pageItem)
          this.setAllQuestionCount(res.erpData.totalCount)
          this.setPageCount(count)
          this.label = 1
        } else {
          this.showMessage(res.erpMsg || '获取问题列表出错')
        }
      })
      clearTimeout(this.redPointTime)
      this.redPointTime = setTimeout(() => {
        this.action_queryQuizRedPoint().then(res => {
          if (res.erpCode === '000') {
            this.setRedPoint(res.erpData)
          }
        })
      }, 1000)
    },
    closeQuestionType () {
      this.isSelectType = false
    },
    getQuestionDetail (id) {
      let newQuestionPage = this.getQuestionPage.map(item => {
        if (item.id === id && item.unreadMessageCount && item.unreadMessageCount !== 0) {
          item.isGetUnread = true
        }
        return item
      })
      this.setQuestionPage(newQuestionPage)
      this.selectedQuestionId = Number.parseInt(id)  // 当前选中问题 id
      this.$router.push({path: '/help', query: {questionId: id, questionHash: Math.random()}})
    },
    submitMessage () {
      if (this.messageContent !== '') {
        let params = {
          quizId: this.questionId,
          message: this.messageContent,
          type: 0,
          fileCode: '',
          isAt: 0
        }
        this.action_addQuestionMessage(params).then(res => {
          if (res.erpCode === '000') {
            this.getQuestionDetail(this.questionId)
            this.messageContent = ''
            return '发布成功'
          } else {
            this.showMessage(res.erpMsg || '评论失败')
          }
        })
      }
    },
    addQuestion () {
      this.editQuiz = false
      this.feedbackShow = !this.feedbackShow
    },
    typeShow (type) {
      switch (type) {
        case 'feedback':
          this.feedbackShow = !this.feedbackShow
          break
        case 'evaluation':
          this.evaluationShow = !this.evaluationShow
          break
        case 'unanswered':
          this.unansweredShow = !this.unansweredShow
          break
      }
    },
    changeFeedbackShow () {
      this.label = 1
      this.feedbackShow = false
      this.setRelatedQuizDetail([])
    },
    unanswered () {
      this.unansweredShow = !this.unansweredShow
    },
    answered () {
      this.evaluationShow = !this.evaluationShow
    },
    confirm (reason, feedbackResult) {
      let params = null
      if (feedbackResult === 'unanswered') {
        params = {
          id: this.questionId,
          isSolved: 0,
          unsolvedType: reason.unsolvedType,
          unsolvedReason: reason.unsolvedReason
        }
      } else if (feedbackResult === 'evaluation') {
        params = {
          id: this.questionId,
          isSolved: 1,
          percent: reason
        }
      }
      this.action_evaluateQuizSolution(params).then(res => {
        let quizId = params.id
        if (params.isSolved === 0) {
          this.unansweredShow = !this.unansweredShow
        } else if (params.isSolved === 1) {
          this.evaluationShow = !this.evaluationShow
        }
        if (res.erpCode === '000') {
          this.$router.push({path: '/help', query: {questionId: quizId, questionHash: Math.random()}})
        } else {
          this.showMessage(res.erpMsg || '评价问题失败')
        }
      })
    },
    editQuestion () {
      if (this.getQuizDetail.status === 0) {
        this.feedbackShow = !this.feedbackShow
        this.editQuiz = true
      } else {
        this.$message({
          showClose: true,
          message: '问题已解答,不可修改',
          type: 'warning'
        })
      }
    },
    cancelQuestion () {
      if (this.getQuizDetail.status === 0) {
        this.$confirm('是否取消提问？', '提示', {
          confirmButtonText: '取消提问',
          cancelButtonText: '继续提问',
          type: 'warning'
        }).then(() => {
          let params = {
            id: this.questionId
          }
          this.action_uerCancelsQuestion(params).then(res => {
            if (res.erpCode === '000') {
              this.setQuestionDetail([])
              let params = {
                currentPage: 0,
                pageSize: this.getPageSize
              }
              this.$router.replace({path: '/help'})
              this.$message({
                type: 'success',
                message: '提问已取消'
              })
              this.setLoading(true)
              this.action_getUserQuestionPage(params).then(res => {
                this.setLoading(false)
                if (res.erpCode === '000') {
                  let count = res.erpData.totalCount ? Math.ceil(res.erpData.totalCount / params.pageSize) : 1
                  this.setQuestionPage(res.erpData.pageItem)
                  this.setAllQuestionCount(res.erpData.totalCount)
                  this.setPageCount(count)
                  this.label = 1
                } else {
                  this.showMessage(res.erpMsg || '获取问题列表出错')
                }
              })
            }  else {
              this.showMessage(res.erpMsg || '删除问题出错')
            }
          })
        }).catch(() => {
        })
      } else {
        this.$message({
          type: 'warning',
          message: '当前问题已解答，无法取消',
          showClose: true
        })
      }
    },
    openSearchList () {
      this.isFocus = true
      if (this.searchQuiz !== '') {
        this.isSearchList = true
      }
      this.isNotFoundList = (this.searchResultList.length === 0)
    },
    closeSearchList () {
      this.isFocus = false
      this.isSearchList = false
    },
    selectQuestion (id) {
      this.feedbackShow = false
      this.setDetailLoading(true)
      this.setMessageLoading(true)
      this.$router.push({path: '/help', query: {questionId: id, questionHash: Math.random()}})
    },
    handler_searchQuiz (val) {
      let params = {
        keyword: val,
        currentPage: 0,
        pageSize: 7
      }
      this.action_searchQuestionPage(params).then(res => {
        if (res.erpCode === '000') {
          this.searchResultList = res.erpData.pageItem
          this.selectSearchListIndex = 0
          this.isNotFoundList = (this.searchResultList.length === 0)
        } else {
          this.showMessage(res.erpMsg || '搜索问题出错')
        }
      })
    },
    // 获取问题详情
    handler_getQuizDetail (id) {
      this.setDetailLoading(true)
      this.setMessageLoading(true)
      this.selectedQuestionId = Number.parseInt(id)  // 当前选中问题 id
      this.$router.push({path: '/help', query: {questionId: id, questionHash: Math.random()}})
    }
  },
  watch: {
    searchQuiz (val) {
      if (val !== '') {
        this.isHideIcon = true
      } else {
        this.isHideIcon = false
      }
      clearTimeout(this.searchTime)
      this.searchTime = setTimeout(() => {
        if (val !== '') {
          this.isSearchList = true
          this.handler_searchQuiz(val)
        } else {
          this.isSearchList = false
          this.searchResultList = []
        }
      }, 500)
    },
    getRouterAddress (val) {
      if (val.questionId !== undefined) {
        this.setDetailLoading(true)
        this.setMessageLoading(true)
        this.questionId = val.questionId
        this.action_getQuizAllDetail(val.questionId).then(res => {
        })
        clearTimeout(this.redPointTime)
        this.redPointTime = setTimeout(() => {
          this.action_queryQuizRedPoint().then(res => {
            if (res.erpCode === '000') {
              this.setRedPoint(res.erpData)
            } else {
              this.showMessage(res.erpMsg || '获取未读红点失败')
            }
          })
        }, 1000)
      }
    },
    getUserId (val) {
      if (val !== '' && val !== undefined) {
        let id = getUrlParam('questionId')
        if (id !== '' && id !== undefined) {
          this.init(id)
        }
      }
    }
  }
}
</script>

<style scoped>
  ::-webkit-input-placeholder { /* WebKit browsers */
    font-size: 15px;
    color: #CCCCCC;
    text-indent: 161px;
    letter-spacing: -0.36px;
  }

  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 15px;
    color: #CCCCCC;
    text-indent: 161px;
    letter-spacing: -0.36px;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 15px;
    color: #CCCCCC;
    text-indent: 161px;
    letter-spacing: -0.36px;
  }

  :-ms-input-placeholder { /* Internet Explorer 10+ */
    font-size: 15px;
    color: #CCCCCC;
    text-indent: 161px;
    letter-spacing: -0.36px;
  }
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #ccc;
  }
  #help {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 1280px;
    max-width: 1356px;
    margin: 0 auto;
    background: #EFEFEF;
    overflow: hidden;
  }

  /* 搜索 */
  .search-wrap {
    display: flex;
    justify-content: center;
    width: 100%;
    background: #f8f8f8;
  }
  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 95%;
    height: 60px;
    line-height: 60px;
  }

  .search-title {
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
  }

  .search-input {
    display: flex;
    height: 33px;
  }

  .add {
    width: 33px;
    height: 33px;
    margin-right: 12px;
    background: url("../../icons/add-question.svg") no-repeat;
    background-size: 33px 33px;
    cursor: pointer;
  }

  .input-wrap {
    position: relative;
    width: 329px;
    height: 33px;
  }
  .input-wrap input {
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    width: 329px;
    height: 33px;
    border: 1px solid #ccc;
    border-radius: 71px;
    color: #333;
    line-height: 33px;
    text-indent: 22px;
    outline: none;
    background: #fff url("../../icons/search.svg") no-repeat 138px center;
  }
  .hide-icon {
    background: #fff !important;
  }
  .search-list {
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    top: 38px;
    width: 290px;
    max-height: 310px;
    /*padding-left: 12px;*/
    border: 1px solid #4A90E2;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(74,144,226,0.58);
    background: #fff;
    overflow-x: hidden;
    overflow-y: scroll;
    z-index: 99;
  }
  .search-list::-webkit-scrollbar {
    width: 0;
  }
  .search-list::-webkit-scrollbar-thumb {
    border-radius: 0;
    background-color: #ccc;
  }
  .not-found-list {}
  .title {
    position: relative;
    left: -8px;
    margin-top: 40px;
    font-size: 17px;
    color: #777777;
    text-align: center;
  }
  .quiz {
    position: relative;
    left: -8px;
    width: 74px;
    height: 44px;
    margin: 17px auto 56px;
    font-size: 17px;
    color: #fff;
    text-align: center;
    line-height: 44px;
    border-radius: 4px;
    background: #4A90E2;
    cursor: pointer;
  }
  .search-item-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .search-item {
    position: relative;
    width: 100%;
    height: 44px;
    padding-left: 12px;
    font-size: 15px;
    color: #333333;
    line-height: 44px;
    letter-spacing: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
  }
  .search-item:after {
    content: "";
    position: absolute;
    bottom: -1px;
    width: 290px;
    right: 0;
    height: 1px;
    background: #DBDBDB;
  }
  .selected-item {
    background: #4a92e2;
    color: #fff;
  }
  .search-item:nth-last-child(1):after {
    height: 0;
  }

  /* 主体内容 */
  .content {
    position: relative;
    z-index: 10;
    display: flex;
    flex: 1;
    justify-content: space-between;
    width: 100%;
    padding: 0 1px;
    overflow: hidden;
    margin-top: 12px;
  }
  .only-one {
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/components/help/help.vue